// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_confirmation_content-module__container--1yCh9"};